import Debug from 'debug';
import * as React from 'react';

const debug = Debug('gfe/au/Logout');

interface LogoutProps {
  signOut: () => Promise<void>;
}

export const Logout = (props: LogoutProps): React.JSX.Element => {
  React.useEffect(() => {
    props.signOut().then(() => {
      window.location.href = '/auth/login';
    });
  }, []);
  return <></>;
};
